<template>
  <div class="stat-card">
    <b>{{ value }}</b>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' }
  }
};
</script>

<style lang="less" scoped>
.stat-card {
  padding-left: 17px;
  border-left: 1px solid rgba(255, 255, 255, 0.16);
}
.stat-card b {
  display: block;
  font-size: 30px;
  color: #83e6ff;
}
.stat-card span {
  color: #7d8aa5;
  font-size: 13px;
}
</style>
